import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { IMyOptions, IMyDateModel } from 'mydatepicker';

import { InlineEditorService } from '../../services/inline-editor.service';
import { Util } from '../../util';
import { Constants } from '../../../app.const';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'inline-editor',
    templateUrl: './inline-edit.component.html'
})

export class InlineEditComponent implements OnInit {
    public todaysDate = new Date();
    public date:any;
    private constants = Constants;
    @Input() value: any;
    @Input() id: any;
    @Input() type: string = 'text';
    @Input() textAlign: string = 'right';
    @Input() width: number = 96;
    @Input() rows: number = 3;
    @Input() selectDate: any = '2017-09-14';
    @Input() dateOptions: IMyOptions = {
        dateFormat: this.constants.dateFormatDatepicker,
        selectionTxtFontSize: '14px',
        editableDateField: false,
        disableUntil: { year: 2016, month: 5, day: 12 },
    };

    public currentYear: number;
    public currentMonth: number;
    public currentDay: number;

    // constructor(
    //     private inlineEditorService: InlineEditorService,
    //     private datePipe: DatePipe,
    // ) { }

    @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
    isEdit = false;
    oldValue: any;
    constructor(private inlineEditorService: InlineEditorService, private datePipe: DatePipe) {
        this.inlineEditorService.status.subscribe((status: any) => {
            if (status.id === this.id) {
                if (this.type === 'date') {
                    this.value = Util.getDateObject(status.value)
                } else {
                    this.value = status.value;
                }
            }
        });
    }

    ngOnInit() {
        this.currentYear = this.todaysDate.getFullYear();
        this.currentMonth = this.todaysDate.getMonth() + 1;
        this.currentDay = this.todaysDate.getDate();

        this.dateOptions.disableUntil.year = this.currentYear;
        this.dateOptions.disableUntil.month = this.currentMonth;
        this.dateOptions.disableUntil.day = this.currentDay - 1;
        if (this.type === 'date') {
            this.value = Util.getDateObject(this.value)
            this.oldValue = Object.assign({}, this.value);
        } else {
            let objetct = { value: this.value };
            this.oldValue = Object.assign({}, objetct);
        }
    }

    onClick(event) {
        this.isEdit = true;
        let date: string;
        if (this.type === 'date') {
            // let date = this.datePipe.transform(this.todaysDate, this.constants.dateFormatDatepicker)
            let dd = this.todaysDate.getDate().toString();
            let mm = (this.todaysDate.getMonth()+1).toString(); //January is 0!
            let yyyy = this.todaysDate.getFullYear().toString();
            date = yyyy.concat("-", mm , "-" , dd); 
            this.value = Util.getDateObject(date);
            // this.value = Util.getDateObject(this.date)
        }
    }

    onBlur() {
        this.isEdit = false;
        if (this.oldValue.value === this.value) {
            this.value = this.oldValue.value;
        } else {
            let emitObject = {
                id: this.id,
                value: this.value
            }
            this.onSave.emit(emitObject);
        }
    }

    onDateChanged(event) {
        let emitObject = {
            id: this.id,
            value: event.formatted
        }
        this.onSave.emit(emitObject);
        if (event.formatted) {
            this.isEdit = false;

        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/modules/inline-editor/inline-edit.component.ts